import { getBasicLogInfo } from './utils';
import { getTargetChangedValue } from '../../../../../../constants/utils';

const deleteNoteLogTransformer = origin => ({
  ...getBasicLogInfo(origin),
  content: getTargetChangedValue(origin, 'content'),
});

export default deleteNoteLogTransformer;
